import { render, staticRenderFns } from "./Shell.vue?vue&type=template&id=fa9dde2a&scoped=true&"
import script from "./Shell.vue?vue&type=script&lang=ts&"
export * from "./Shell.vue?vue&type=script&lang=ts&"
import style0 from "./Shell.vue?vue&type=style&index=0&id=fa9dde2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9dde2a",
  null
  
)

export default component.exports